import { render, staticRenderFns } from "./UiTableOrderInStatusReport.vue?vue&type=template&id=7253c794&scoped=true&"
import script from "./UiTableOrderInStatusReport.vue?vue&type=script&lang=js&"
export * from "./UiTableOrderInStatusReport.vue?vue&type=script&lang=js&"
import style0 from "./UiTableOrderInStatusReport.vue?vue&type=style&index=0&id=7253c794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253c794",
  null
  
)

export default component.exports